import { Shell, StepFooter } from "@/components/Shell";
import { OptionList } from "@/components/OptionList";
import { AGE_RANGES, MENSTRUAL_QUESTIONS } from "@/lib/questions";

export function MenstrualStep({ answers, setAnswer, onBack, onNext, progress }) {
  const canContinue =
    answers.age_range &&
    MENSTRUAL_QUESTIONS.every((q) => answers[q.id]);

  return (
    <Shell progress={progress}>
      <span className="cc-eyebrow">Etapa menstrual</span>
      <h1 className="font-serif text-3xl sm:text-4xl mt-3">
        Cuéntanos sobre tu ciclo
      </h1>
      <p className="mt-3 text-[hsl(var(--muted-foreground))]">
        Estas preguntas nos ayudan a organizar tu situación. Nunca afirmaremos que
        estás en menopausia.
      </p>

      <div className="mt-8 space-y-6">
        <div className="cc-card p-5">
          <p className="font-medium mb-3">¿En qué rango de edad te encuentras?</p>
          <OptionList
            name="Rango de edad"
            options={AGE_RANGES}
            value={answers.age_range}
            onChange={(v) => setAnswer("age_range", v)}
            testIdPrefix="age"
          />
        </div>

        {MENSTRUAL_QUESTIONS.map((q) => (
          <div key={q.id} className="cc-card p-5">
            <p className="font-medium mb-3">{q.text}</p>
            <OptionList
              name={q.text}
              options={q.options}
              value={answers[q.id]}
              onChange={(v) => setAnswer(q.id, v)}
              testIdPrefix={q.id}
            />
          </div>
        ))}
      </div>

      <StepFooter>
        <button onClick={onBack} className="cc-btn-outline" data-testid="menstrual-back-btn">
          Atrás
        </button>
        <button
          onClick={onNext}
          disabled={!canContinue}
          className="cc-btn-primary"
          data-testid="menstrual-next-btn"
        >
          Continuar
        </button>
      </StepFooter>
    </Shell>
  );
}
